import { permissionCode } from "src/app/shared";
import { FeaturePermissionState } from "../permission.models";

export const releaseDetailPermissionState: FeaturePermissionState = {
  view: [permissionCode.TASK_MANAGEMENT_RELEASE_RELEASE_DETAIL_VIEW],
  viewAnother: [permissionCode.TASK_MANAGEMENT_RELEASE_RELEASE_DETAIL_VIEW_OTHER],
  edit: [permissionCode.TASK_MANAGEMENT_RELEASE_RELEASE_DETAIL_EDIT],
  editAnother: [permissionCode.TASK_MANAGEMENT_RELEASE_RELEASE_DETAIL_EDIT_OTHER],
};
